import React, { JSX, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Table from '../../components/Table';
import { PATHS } from 'src/common/constants';
import Actions from '../../components/Actions';
import Empty from '../../components/Empty';
import Loader from '../../components/Loader';
import { variables } from 'src/Tenants';
import Search from 'src/components/Search/Search';
import { useTablePagination } from 'src/SharedCustomHooks/UseTablePagination/useTablePagination';
import useProperties from 'src/utils/CommonDataFetchingUtils/useProperties';

interface ContactPropertiesProps {
  contact: {
    id: string | number;
    firstname?: string;
    lastname?: string;
  };
}

const ContactProperties = ({ contact }: ContactPropertiesProps): JSX.Element => {
  const contactName: string = [contact?.firstname, contact?.lastname]
    .filter(Boolean)
    .join(' ');

  const {
    homeownerData: properties,
    homeownerLoading: loading,
    fetchHomeownerProperties,
  } = useProperties();
  const [searchQuery, setSearchQuery] = useState<string>('');

  const { itemsPerPage, onItemsPerPageChange } = useTablePagination();

  useEffect(() => {
    void fetchHomeownerProperties(contact.id);
  }, [contact.id]);

  const filteredProperties: any[] = (properties ?? []).filter((item: any) => {
    if (!searchQuery) {
      return true;
    }

    const term: string = searchQuery.toLowerCase();
    return (
      item.name?.toLowerCase().includes(term) ||
      item.addressLine1?.toLowerCase().includes(term) ||
      item.number?.toLowerCase().includes(term) ||
      item.isPrimaryContact?.toLowerCase().includes(term)
    );
  });

  return (
    <div>
      <Actions compact>
        <Search
          size="small"
          placeholder="Search Properties..."
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSearchQuery(e.target.value.trim())
          }
          theme={undefined}
        />
      </Actions>
      {filteredProperties.length > 0 ? (
        <Table
          columns={[
            {
              label: 'Property',
              accessor: 'name',
              sortable: true,
              cell: (data: any) => (
                <Link
                  to={{
                    pathname: PATHS.PROPERTIES_VIEW.replace(
                      ':id',
                      data.propertyId
                    ),
                    state: {
                      navOrigin: {
                        kind: 'contact',
                        contactId: contact.id,
                        contactName,
                      },
                    },
                  }}
                >
                  {data.name}
                </Link>
              ),
            },
            {
              label: 'Address',
              accessor: 'addressLine1',
            },
            {
              center: true,
              xsHide: true,
              label: variables.Suite + 's',
              accessor: 'number',
            },
            {
              center: true,
              xsHide: true,
              label: 'Primary Contact',
              accessor: 'isPrimaryContact',
            },
          ]}
          data={filteredProperties}
          paginate={{ itemsPerPage, position: 'both' }}
          onItemsPerPageChange={onItemsPerPageChange}
        />
      ) : loading ? (
        <Loader />
      ) : (
        <Empty
          direction="ttb"
          headline="No properties yet"
          strapline="All properties you add will be listed here so it's easier for you to manage."
          // @ts-expect-error - todo: legacy BOS code - fix this typing contract issue.
          searchIsActive={filteredProperties.length ? filteredProperties : ''}
          cta={''}
          image={
            <img alt="No properties yet" src="/assets/empty/properties.svg" />
          }
        />
      )}
    </div>
  );
};

export default ContactProperties;
